<template>
  <div class="main">
    <div class="pageTitle">
     <p>日常工作工时统计 - 按人员</p>
     <span style="margin-left:20px;font-size:14px;line-height:40px;">单位：人天</span>
      <div style="float:right">
        <currentDate></currentDate>
      </div>
    </div>
    <div class="searchArea">
      <div class="weekly_search">
        <div class="search_input">
          <el-input v-model="listQuery.Parameters.organizationName" autocomplete="off" readonly></el-input>
          <div class="input_chooseBtn">
            <el-button type="text" size="medium" @click="showChooseOrganizationView">选择</el-button>
            <el-button type="text" size="medium" @click="clearOrganization">清除</el-button>
          </div>
        </div>
        <el-select
          v-model="listQuery.Parameters.organizationSearchMode"
          placeholder
          style=" width: 250px;">
          <el-option
            v-for="item in organizationSearchModeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"></el-option>
        </el-select>
        <!-- <el-select
          v-model="listQuery.Parameters.taskId"
          placeholder="请选择日常工作类型"
          style=" width: 150px;">
          <el-option
            v-for="item in saerchTaskList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select> -->
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          value-format="yyyy/MM/dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="margin-left:10px; width:300px;"></el-date-picker>
          <div style="display: inline-block;">
            <el-button size="small" @click="searchTable">查询</el-button>
            <el-button size="small" @click="exportToExcel">导出查询结果</el-button>
          </div>
      </div>
      
    </div>
    <div class="tableContainer" style="top: 120px;">
      <div class="tableContent">
        <el-table :data="spentTimeData" border stripe>
            <el-table-column label="日常工作" width="250"  fixed="left">
            <template slot-scope="props">
              <el-button type="text" size="mini" @click="showTaskReportView(props.row)">
                {{
                props.row.taskName
                }}
              </el-button>
            </template>
          </el-table-column>

            <el-table-column v-for="val in userList" :key="val" width="120">
              <template slot="header">
                {{
                val.split('-')[1]
                }}
              </template>
              <template slot-scope="props">{{props.row[val]| hoursToDays}}</template>
            </el-table-column>
            <el-table-column label="总计" width="100" fixed="left">
              <template slot-scope="props">
               {{props.row.taskSpentTime | hoursToDays}}
              </template>
            </el-table-column>
        </el-table>
      </div>

      <div class="tablePagesNumber">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listQuery.PagingInfo.currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="listQuery.PagingInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.PagingInfo.totalCount"
        ></el-pagination>
      </div>
    </div>

    <chooseOrganization ref="chooseOrganization" 
          :propsData="organizationChooseViewProps"
        @chooseOrganizationCallback="chooseOrganizationCallback">
        </chooseOrganization>

      <taskReportDialog
      ref="taskReportDialog"
      :taskReportDialogProps="taskReportDialogProps"></taskReportDialog>
      
  </div>
</template>
<script>
import { dateFtt } from "@/utils/auth.js";
import currentDate from "../common/currentDate";
import chooseOrganization from "../common/chooseOrganization";
import taskReportDialog from "../report/taskReportDialog";

export default {
  name: "taskSpentTime",
  components: { chooseOrganization,currentDate,taskReportDialog },
  data() {
    return {
       taskReportDialogProps: {
        visible: false
      },
      organizationChooseViewProps: {
        visible: false,
        includeRemoved:true
      },
      listQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          organizationSearchMode: 0,
          organizationIdPath: "",
          organizationId: this.$userContext.getOrganizationId(),
          organizationName: this.$userContext.getOrganizationName(),
          startDate: "",
          endDate: ""
        }
      },
      dateRange: [],
      currentLineInfo: {},
      organizationSearchModeList: [
        { id: 0, name: "当前组织机构及下级所有组织机构" },
        { id: 1, name: "仅当前组织机构" }
      ],
      spentTimeData: [],
      userList:[],
      noRole: false
    };
  },
  mounted() {
     let dateTime = this.$userContext.getDateTime();
    if(dateTime!=null)
    {
      this.dateRange = [];
      this.dateRange.push(dateFtt("yyyy/MM/dd",dateTime.currentMonthFirstDay));
      this.dateRange.push(dateFtt("yyyy/MM/dd",dateTime.currentMonthLastDay));
    }

    this.searchTable();
  },
  methods: {

    showTaskReportView(current) {
      this.$refs.taskReportDialog.show(current.taskId);
    },

    getSearchArgs()
    {
      if (this.dateRange == null) {
        this.listQuery.Parameters.startDate = "";
        this.listQuery.Parameters.endDate = "";
      } else {
        this.listQuery.Parameters.startDate = this.dateRange[0];
        this.listQuery.Parameters.endDate = this.dateRange[1];
      }


    if(this.listQuery.Parameters.organizationId == null || this.listQuery.Parameters.organizationId == ""){
        this.listQuery.Parameters.organizationId = this.$userContext.getOrganizationId();
        this.listQuery.Parameters.organizationName = this.$userContext.getOrganizationName();
      }

      let submitForm = JSON.parse(JSON.stringify(this.listQuery));
      if (submitForm.Parameters.organizationSearchMode == 0) 
      {
        submitForm.Parameters.organizationIdPath = submitForm.Parameters.organizationId;
        submitForm.Parameters.organizationId = "";
      } 
      else 
      {
        submitForm.Parameters.organizationIdPath = "";
      }

      return submitForm;
    },

    searchTable() {

      this.$reportApi.getTaskSpentTimeDataTableByUser(this.getSearchArgs())
        .then(res => {
          if (res.data.successful) {
            this.spentTimeData = res.data.data.data;
            this.getTableUserList()
            this.listQuery.PagingInfo.totalCount = res.data.data.pagingInfo.totalCount;
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
    },

    exportToExcel()
    {
      this.$reportApi.exportTaskSpentTimeDataTableByUser(this.getSearchArgs())
      .then(res => {
        console.log(res);
          if (res.data.successful) {
            window.open(window.Glob.BASE_URL + "/" + res.data.data.url);
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
    },

    getTableUserList(){
        let userList = [];
        this.spentTimeData.forEach(item=>{
            for(let key in item){
                if(key.indexOf('-') !='-1'){
                    userList.push(key)
                }
            }
        })
        // 数组去重
        this.userList =[...new Set(userList)];
    },
    
    handleSizeChange(val) {
      this.listQuery.PagingInfo.pageSize = val;
      this.searchTable();
    },
    handleCurrentChange(val) {
      this.listQuery.PagingInfo.currentPage = val;
      this.searchTable();
    },

     //选择组织机构
    showChooseOrganizationView() {
      let organizationId = "";

      if(this.$userContext.checkAuthorizationAny(["WeeklyReport_SpentTimeReport_All"]) == false)
      {
           organizationId = this.$userContext.getOrganizationId();
      }
      
      this.$refs.chooseOrganization.show(organizationId);
    },
    clearOrganization() {
      this.listQuery.Parameters.organizationId = "";
      this.listQuery.Parameters.organizationName = "";
    },
    chooseOrganizationCallback(data) {
      this.listQuery.Parameters.organizationId = data.id;
      this.listQuery.Parameters.organizationName = data.name;
    },

  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.search_input {
  width: 220px;
  position: relative;
  display: inline-block;
  margin-right: 10px;
}
.weekly_search {
  
  margin-top: 20px;
}
.el-date-editor .el-range-separator {
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/report/taskSpentTime.vue